import React from "react";
import useAxios from "axios-hooks";
import FluentSelect from "../../../../../Forms/FluentSelect";

const CobrandTagsDropdown = ({ setOptionTable, ...rest }) => {
  const [{ data: cobrandTags, loading: loadingCobrandTags }] = useAxios(
    "/internal/tags"
  );

  const cobrandTagsOptions =
    cobrandTags &&
    cobrandTags.map((cobrandTag) => ({
      value: cobrandTag.coBrandTagID,
      label: cobrandTag.name,
    }));

  return (
    <FluentSelect
      options={cobrandTagsOptions}
      disabled={loadingCobrandTags}
      isMulti
      {...rest}
    />
  );
};

export default CobrandTagsDropdown;
